export enum TransportType {
  UNSET_TRANSPORT_TYPE = 'UNSET_TRANSPORT_TYPE', // Do not use, needed because of proto3 limitations
  SMS = 'SMS',
  PUSH = 'PUSH',
  WHATSAPP = 'WHATSAPP',
}
